<template>
  <section :class="{
    'style-round': cornerStyle === 'round',
    'style-square': cornerStyle === 'square',
    fontLoaded
  }">
    <button :style="{ fontFamily: fontFamilyCSS }" 
      @click="followNextLink"
    >{{buttonTitle}}
    </button>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'NextButton',
  props: {
  },
  computed: {
    ...mapState('poll', [
      'WEBNextLinkButtonTitle',
      'cornerStyle',
      'fontLoaded',
      'votingEnabled',
      'next'
    ]),
    ...mapGetters('poll', [
      'fontFamilyCSS',
      'nextLink'
    ]),
    ...mapGetters('pollGroup', [
      'hasNextPoll',
      'pollGroupModeActive',
      'isNextPollLoading'
    ]),
    buttonTitle() {
      return this.pollGroupModeActive && (this.hasNextPoll && 'Next' || 'Finish') || this.WEBNextLinkButtonTitle;
    }
  },
  methods: {
    ...mapActions('pollGroup', [
      'nextPoll'
    ]),
    ...mapActions('voter', [
      'switchView'
    ]),
    followNextLink(e) {
      e.preventDefault();
      if (this.pollGroupModeActive) {
        this.hasNextPoll ? this.nextPoll() : this.switchView('congratulations');
      } else if (this.nextLink) {
        window.location.href = this.nextLink;
      }
    }
  }
}
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  width: 100%;
  margin: 0 !important;
  position: relative;
  z-index: 1;
}

button {
  font-size: var(--answer-fontsize);
  line-height: 1em;
  padding: 16px 20px 14px;
  text-align: center;
  border: none;
  border-radius: var(--button-radius);
  display: block;
  background-color: var(--button-bg);
  color: var(--button-color);
  cursor: pointer;
  opacity: 0;
  outline: none;
  width: 100%;
  margin: 0 auto;
  min-width: 100px;
  word-break: break-all;

  &:disabled {
    cursor: not-allowed;
  }
}

.style-square {

  button {
    border-radius: 4px;
  }
}

.fontLoaded {

  button {
    opacity: 1;

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>